import { render, staticRenderFns } from "./BeatTap.vue?vue&type=template&id=12e5eede&"
import script from "./BeatTap.vue?vue&type=script&lang=js&"
export * from "./BeatTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports